/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowSearchBanner_user" | "SbSharedFollowSearchProvider_user" | "SbSharedNullSearchRelatedItems_user">;
    readonly " $refType": "SbRespNullSearchResults_user";
};
export type SbRespNullSearchResults_user$data = SbRespNullSearchResults_user;
export type SbRespNullSearchResults_user$key = {
    readonly " $data"?: SbRespNullSearchResults_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNullSearchResults_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_user",
      "args": null
    }
  ]
};
(node as any).hash = '9fc3d047d25a19ee6fba6e41b66a2afa';
export default node;
